import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContext } from '../../types';
import { IInformationCard } from '../../types/content';
import {
  InformationCardItemContainer, InformationCardItemDescription,
  InformationCardItemTitle,
  InformationCardSection, InformationCardSvgAndTitle
} from './InformationCardsStyle';
import { getSvgComponent } from '../utils/svg';
import Fade from 'react-reveal/Fade';

{/*Dangerously set inner html added for wanted text effects*/}
const InformationCardsContainer = ({ context }: IContext) => {
  return (
    <InformationCardSection>
      {context.informationCard.map((card: IInformationCard, index) =>
        <InformationCardItemContainer key={'Information card ' + index}>
          <InformationCardSvgAndTitle>
            <Fade top distance={'20px'}>
              {getSvgComponent(card.linkedSvg)}
            </Fade>
            <InformationCardItemTitle dangerouslySetInnerHTML={{ __html: card.title }} />
          </InformationCardSvgAndTitle>
          <InformationCardItemDescription dangerouslySetInnerHTML={{ __html: card.description }} />
        </InformationCardItemContainer>
      )}
    </InformationCardSection>
  );
};

export default withContent(InformationCardsContainer);